import React, {useEffect, useState} from "react";
import {Table} from "antd";
import ResizeableTitle from "./ResizableTitle";

const CustomResizableTable = props => {
  const {data, columns, setShowColumns, ...restProps} = props;
  const [state, setState] = useState<any>({
    isResizing: false,
    columns: [],
  });
  const components = {
    header: {
      cell: ResizeableTitle,
    },
  };

  const handleResize =
    index =>
    (e, {size}) => {
      const nextColumns = [...state.columns];
      nextColumns[index] = {
        ...nextColumns[index],
        width: size.width,
      };

      setState({...state, columns: nextColumns});
    };

  const onResizeStart = (e, data) => {
    setState({...state, isResizing: true});
  };

  const onResizeStop = (e, data) => {
    let tmp = state.columns?.map(it => {
      let dt = {...it};
      delete dt.render;
      return {
        ...it,
      };
    });
    setShowColumns(tmp);
    setState({...state, isResizing: false});
  };
  const tableColumns = state.columns.map((col, index) => ({
    ...col,
    onHeaderCell: column => ({
      isResizable: column.isResizable,
      width: column.width,
      onResize: handleResize(index),
      onResizeStart: onResizeStart,
      onResizeStop: onResizeStop,
    }),
  }));
  useEffect(() => {
    setState({...state, columns: columns});
  }, [columns]);
  useEffect(() => {}, [state]);
  return (
    <Table
      components={components}
      columns={tableColumns}
      // scroll={{x: 1600}}
      tableLayout="auto"
      dataSource={data}
      {...restProps}
    />
  );
};

export default CustomResizableTable;
